import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "toast-container position-fixed bottom-0 end-0 p-3" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "toast-body" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close btn-close-white me-2 m-auto",
  "data-bs-dismiss": "toast",
  "aria-label": "Close"
}, null, -1)

import {
    GlobalMessage,
    useGlobalMessagesStore,
} from "@/stores/globalMessagesStore";
import { computed, onUpdated } from "vue";
import { Toast } from "bootstrap";

export default /*#__PURE__*/_defineComponent({
  __name: 'SystemAlerts',
  setup(__props) {

const globalMessages = useGlobalMessagesStore();

const getClass = function (item: GlobalMessage) {
    switch (item.type) {
        case "error":
            return "text-bg-danger";
        case "warning":
            return "text-bg-warning";
        case "info":
            return "text-bg-info";
        case "success":
            return "text-bg-success";
    }
};
const messages = computed(() => {
    return globalMessages.messages;
    // return globalMessages.messages.filter((obj) => {
    //     return obj.show != true;
    // });
});
onUpdated(() => {
    const toastElList = document.querySelectorAll(".toast");

    toastElList.forEach((x, index) => {
        const toast = new Toast(x);
        toast.show();

        x.addEventListener("hidden.bs.toast", function () {
            globalMessages.deleteByIndex(index);
        });
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(`toast align-items-center border-0 ${getClass(item)}`),
        key: `message_${index}`,
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(item.message), 1),
          _hoisted_4
        ])
      ], 2))
    }), 128))
  ]))
}
}

})